import { template as _$template } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=flight__best-mission-rank data-testid=best-mission-rank>Congratulations, you ranked number <!> in best mission scores recorded.`);
import { Show } from "solid-js";
import { BestMissionPrompt } from "./BestMissionPrompt.tsx";

/**
 * BEST MISSIONS' whole presence inside `/fly`: the name prompt while a
 * qualifying score is waiting to be recorded, and afterwards the placement
 * line — `PS.EXE`'s own wording, `"Congratulations, you ranked number %r in
 * best mission scores recorded."` (`docs/game/missions.md`/`campaign.md`).
 * The same one-component shape `vcr/FlightRecorderOverlay.tsx` uses for SAVE
 * FLIGHT, for the same reason: the prompt is only ever replaced by its own
 * result.
 */
export function BestMissionOverlay(props) {
  return [_$createComponent(Show, {
    get when() {
      return props.recording.prompting();
    },
    get children() {
      return _$createComponent(BestMissionPrompt, {
        get missionTitle() {
          return props.missionTitle;
        },
        get score() {
          return props.score;
        },
        get onSave() {
          return props.recording.save;
        },
        get onCancel() {
          return props.recording.skip;
        }
      });
    }
  }), _$createComponent(Show, {
    get when() {
      return props.recording.rank();
    },
    children: rank => (() => {
      var _el$ = _tmpl$(),
        _el$2 = _el$.firstChild,
        _el$4 = _el$2.nextSibling,
        _el$3 = _el$4.nextSibling;
      _$insert(_el$, rank, _el$4);
      return _el$;
    })()
  })];
}